import { render, staticRenderFns } from "./fansIndex.vue?vue&type=template&id=0554161d"
import script from "./fansIndex.vue?vue&type=script&lang=js"
export * from "./fansIndex.vue?vue&type=script&lang=js"
import style0 from "./fansIndex.vue?vue&type=style&index=0&id=0554161d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports